import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import * as locationReducers from '../locations/state/locations-reducers';
import * as shoppingCartReducers from '../products/state/shopping-cart/cart-reducers';
import * as searchReducers from '../products/state/product-search/search-reducers';
import * as fromStorage from '../storage/storage.state';
import * as contactsReducers from '@app/marketplace/checkout/state/contacts/contacts-reducers';
import * as categoryTreeReducers from '@app/marketplace/categories/state/category-tree/category-tree-reducers';
import * as productDetailsReducers from '@app/marketplace/products/state/product-details/details-reducers';


export const layoutReducer: ActionReducerMap<fromStorage.AppStorageState> = {
  location: locationReducers.reducer, //key: location
  basket: shoppingCartReducers.reducer, //key: shoppingcart
  search: searchReducers.reducer, //key: search
  contacts: contactsReducers.reducer, //key contacts
  categoryTree: categoryTreeReducers.reducer,
  product_details: productDetailsReducers.reducer //key product_details
};

export function locationStorageSyncReducer(reducer: ActionReducer<fromStorage.AppStorageState>) {
  return localStorageSync({
    //keys: Object.keys(layoutReducer),
    //keys: ['location','search'],
    keys: ['location'],
    storageKeySerializer: (key: string) =>{ return `${key}`},
    rehydrate: true,
    storage: window.localStorage,
  })(reducer);
}
export const metaReducers: MetaReducer<fromStorage.AppStorageState>[] = typeof window !== 'undefined' ? [locationStorageSyncReducer] : [];
